import { Button, Descriptions, Modal } from 'antd';

import Pill from './Pill';
import useModalControls from 'hooks/useModalControls';
import { DEBT_SALE_STATUS } from 'utilities/constants';
import { formatDate } from 'utilities/datesAndTimes';

const DebtSalePill = ({ account, displayBuyer = true }) => {
  const debtBuyerModal = useModalControls();
  const debtSaleInfo = account?.accountDetails?.debtSaleInfo;

  const debtSold = debtSaleInfo?.status === DEBT_SALE_STATUS.SOLD;
  const debtRepurchased = debtSaleInfo?.status === DEBT_SALE_STATUS.REPURCHASED;
  const buyerName = debtSaleInfo?.debtBuyerInfo?.buyerName;
  const saleDate = debtSaleInfo?.dateSold;

  return debtSold || debtRepurchased ? (
    <Pill data-testid="debt-buyer" color="magenta">
      {debtRepurchased ? `Debt Sold - REPURCHASED` : 'Debt Sold'}
      {displayBuyer && buyerName ? (
        <>
          <DebtBuyerInfoModal
            debtBuyerInfo={debtSaleInfo?.debtBuyerInfo}
            saleDate={saleDate}
            {...debtBuyerModal}
          />
          {': '}
          <Button
            data-testid="debt-buyer-info-button"
            onClick={debtBuyerModal.show}
            type="link"
            style={{
              padding: 0,
              height: 'unset',
              fontSize: 'var(--font-size-sm)',
            }}
          >
            {buyerName}
          </Button>
        </>
      ) : undefined}
    </Pill>
  ) : undefined;
};

const DebtBuyerInfoModal = ({
  debtBuyerInfo = {},
  saleDate,
  ...modalProps
}) => {
  return (
    <Modal
      title="Debt Buyer Information"
      cancelButtonProps={{ hidden: true }}
      {...modalProps}
    >
      <Descriptions
        column={1}
        style={{ paddingTop: 'var(--spacing)' }}
        items={[
          {
            key: '1',
            label: 'Name',
            children: (
              <span data-testid="debt-buyer-name">
                {debtBuyerInfo.buyerName || '-'}
              </span>
            ),
          },
          {
            key: '2',
            label: 'Address',
            children: (
              <span data-testid="debt-buyer-address">
                {debtBuyerInfo.address || '-'}
              </span>
            ),
          },
          {
            key: '3',
            label: 'Phone Number',
            children: (
              <span data-testid="debt-buyer-phone">
                {debtBuyerInfo.contactNumber || '-'}
              </span>
            ),
          },
          {
            key: '4',
            label: 'Email',
            children: (
              <span data-testid="debt-buyer-email">
                {debtBuyerInfo.email || '-'}
              </span>
            ),
          },
          {
            key: '5',
            label: 'Website',
            children: (
              <span data-testid="debt-buyer-website">
                {debtBuyerInfo.website || '-'}
              </span>
            ),
          },
          {
            key: '6',
            label: 'Date Sold',
            children: (
              <span data-testid="date-sold">{formatDate(saleDate) || '-'}</span>
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default DebtSalePill;
